import src from "IMAGE";
export default { src, width: 2000, height: 1000, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQUlEQVR42n2NOQoAIRAE/f8LN9lARTxQ8UajFgOjAYOChi4oVsfCC3aHiQ3SZXCboEOlwjk/4fGrCOULFcqhT5LYs7h67euJFrsAAAAASUVORK5CYII="};
